var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._t("title"),_vm._t("description"),_c('user-flow-step',{attrs:{"steps":_vm.steps}}),_vm._t("note"),_c('brand-button',{staticClass:"statusButton",on:{"click":_vm.onClick}},[_vm._t("buttonLabel")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }